import api from '../service/imprimirSolicitacao.service';
import relatorioGerencialHelper from '@common/components/relatorioGerencial/emissao/relatorioGerencialHelper';
import * as types from './imprimirSolicitacao.actionTypes';
import formActions from '@common/store/form/form.actions';
import { takeEvery, call, put, select } from 'redux-saga/effects';
import imprimirSolicitacaoActions from './imprimirSolicitacao.actions';
import imprimirSolicitacaoSelector from './imprimirSolicitacao.selectors';

export default workSaga;

function* workSaga() {
  yield takeEvery(types.PESQUISAR_IMPRIMIR_SOLICITACAO_MODAL, pesquisarImprimirSolicitacaoModal);
  yield takeEvery(types.PESQUISAR_IMPRIMIR_SOLICITACAO, pesquisarImprimirSolicitacao);
  yield takeEvery(types.ABRIR_IMPRIMIR_SOLICITACAO, abrirImprimirSolicitacao);
}

function* pesquisarImprimirSolicitacaoModal(action) {
  const { payload } = action;

  try {
    const state = yield select(imprimirSolicitacaoSelector.imprimirSolicitacao);

    const validaRecaptchaModal = state?.tokenRecaptchaModal != '' && state?.tokenRecaptchaModal != undefined;

    if (!validaRecaptchaModal) {
      yield resetRecaptchaModal();
      return _alert.warning('É necessário validar o ReCaptcha.');
    }

    var result = yield call(api.consultarProtocoloByCpfCnpj, payload, {
      headers: { tokenRecaptcha: state?.tokenRecaptchaModal },
    });

    yield put(imprimirSolicitacaoActions.toggleModalImprimirSolicitacao());
    yield put(imprimirSolicitacaoActions.setImprimirSolicitacaoGridPesquisa(result.data));
    yield put(formActions.gridReload());
  } catch {
    yield resetRecaptchaModal();
    yield put(formActions.redirect('redeSIM.imprimirSolicitacao'));
    yield put(imprimirSolicitacaoActions.toggleModalImprimirSolicitacao());
    yield put(imprimirSolicitacaoActions.limpaGridsImprimirSolicitacao());
  }
}

function* pesquisarImprimirSolicitacao(action) {
  const { payload } = action;

  try {
    const state = yield select(imprimirSolicitacaoSelector.imprimirSolicitacao);

    const validaRecaptcha = state?.tokenRecaptcha != '' && state?.tokenRecaptcha != undefined;

    if (!validaRecaptcha) {
      yield resetRecaptcha();
      return _alert.warning('É necessário validar o ReCaptcha.');
    }

    const result = yield call(api.imprimirSolicitacao, payload.NumeroProtocolo, {
      headers: { tokenRecaptcha: state?.tokenRecaptcha },
    });

    yield put(imprimirSolicitacaoActions.setImprimirSolicitacaoGridPesquisa([]));
    yield put(formActions.gridReload());

    relatorioGerencialHelper.openReport(result);
    yield resetRecaptcha();
  } catch {
    yield resetRecaptcha();
    yield put(formActions.redirect('redeSIM.imprimirSolicitacao'));
    yield put(imprimirSolicitacaoActions.limpaGridsImprimirSolicitacao());
  }
}

function* abrirImprimirSolicitacao(action) {
  const { payload } = action;

  try {
    const result = yield call(api.imprimirSolicitacaoGrid, payload.NumeroProtocolo);
    yield put(imprimirSolicitacaoActions.setImprimirSolicitacaoGridPesquisa([]));
    yield put(formActions.gridReload());

    relatorioGerencialHelper.openReport(result);
  } catch {
    yield put(formActions.redirect('redeSIM.imprimirSolicitacao'));
    yield put(imprimirSolicitacaoActions.limpaGridsImprimirSolicitacao());
  }
}

function* resetRecaptcha() {
  const state = yield select(imprimirSolicitacaoSelector.imprimirSolicitacao);
  if (state?.recaptchaResetRef) state.recaptchaResetRef.call();
  yield put(imprimirSolicitacaoActions.setTokenRecaptcha(''));
}

function* resetRecaptchaModal() {
  const state = yield select(imprimirSolicitacaoSelector.imprimirSolicitacao);
  if (state?.recaptchaResetRefModal) state.recaptchaResetRefModal.call();
  yield put(imprimirSolicitacaoActions.setTokenRecaptchaModal(''));
}
